export default __webpack_public_path__ + "static/media/bg-masthead-1-320w.16201684.jpg";